import type { BiletsList } from '@/api/bilets';
import { cached } from '@/api/cache';
import type { Progress } from '@/api/me';

const WRITE_WAIT_MS = 4000;

let answerWrites: Promise<unknown> = Promise.resolve();

export function trackAnswerWrite<T>(write: Promise<T>): Promise<T> {
  const bounded = new Promise<void>((resolve) => {
    const timer = setTimeout(resolve, WRITE_WAIT_MS);
    const done = () => {
      clearTimeout(timer);
      resolve();
    };
    write.then(done, done);
  });
  answerWrites = Promise.all([answerWrites, bounded]);
  void write.then(
    () => invalidateAnswerCaches(),
    () => {},
  );
  return write;
}

export function afterAnswerWrites<T>(load: () => Promise<T>): Promise<T> {
  return answerWrites.then(load, load);
}

const ANSWER_TTL_MS = 60_000;

export const progressCache = cached<Progress>(ANSWER_TTL_MS);

export const wrongCountCache = cached<number>(ANSWER_TTL_MS);

export const biletlarCache = cached<BiletsList>(ANSWER_TTL_MS);

export function invalidateAnswerCaches(): void {
  progressCache.invalidate();
  biletlarCache.invalidate();
  wrongCountCache.invalidate();
}
